import React, { useState } from "react";
import { ContextMenu } from "react-contextmenu";

export default function Menu({ id, menuItems, menuClass }){
	let [isMenuShowing, toggleMenu] = useState()
		, itemList = [];

	if(isMenuShowing){
		itemList = menuItems;
	}

	function showMenu(){
		toggleMenu(true);
	}

	function hideMenu(){
		toggleMenu(false);
	}

	return (
		<ContextMenu
			id={`context-menu-${id}`}
			onShow={showMenu}
			onHide={hideMenu}
			className={menuClass}
		>
			{ itemList }
		</ContextMenu>
	);
}
